 <app-panel-page></app-panel-page>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/app.component.html